import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { LineLogin } from 'reactjs-line-login';
import AppleLogin from 'react-apple-login'
import { Button, Divider } from 'antd';
import { apiGetDeepToken } from '../../services/apis/profile'

import 'reactjs-line-login/dist/index.css';
import 'antd/dist/antd.css';
import './Login.css'


const Login = () => {

    const [payload, setPayload] = useState(null);
    const [idToken, setIdToken] = useState(null);
    const history = useHistory();

    useEffect(async () => {
        if (localStorage.getItem('rondori_token')) {
            history.push("/home")
        }else{
            let timeout1 = setInterval(async () => {
                let deep_token = await apiGetDeepToken()
                console.log(deep_token)
                if (deep_token && deep_token.status) {
                    console.log(deep_token.token)
                    localStorage.setItem('rondori_token', deep_token.token)
                    localStorage.setItem('rondori_user', JSON.stringify(deep_token.result))
                    history.push("/home")
                }
            }, 1000);
    
            return () => {
                clearInterval(timeout1)
            }
            
        }
    }, [])

    const makeid = (length) => {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
       }
       return result;
    }

    const getNonce = () => {
        var nonce = localStorage.getItem("rondori_nonce")
        console.log(nonce)
        if(nonce){
            return nonce
        }else{
            nonce = makeid(32)
            localStorage.setItem("rondori_nonce",nonce)
            return nonce
        }
    }

    return (
        <div className="App">
            <div>
                <div className="rondori">
                    <img className="img-logo" alt="Logo" src="/assets/rondori/Logo.png" />
                    <h1 className='app-name'>Rondori</h1>
                </div>

                <div className="cov-btn">
                    <LineLogin
                        clientID='1656814511'
                        clientSecret='438abb1fa6eb4df2e379bcaff634efc9'
                        state={new Date().getTime()}
                        nonce={getNonce()}
                        redirectURI='https://rondori.com/home?type=line'
                        // redirectURI='https://test.rondori.com/home?type=line'
                        scope='profile openid email'
                    // setPayload={setPayload}
                    // setIdToken={setIdToken}
                    />

                    <AppleLogin
                        clientId="com.rondori.www"
                        redirectURI="https://rondori.com/home?type=apple"
                        scope='name email'
                        responseType={"code"}
                        responseMode={"query"}
                        usePopup={false}
                        onSuccess={(response) => console.log(response)}
                        designProp={
                            {
                                height: 40,
                                width: 140,
                                color: "black",
                                border: false,
                                type: "sign-in",
                                border_radius: 15,
                                scale: 1,
                                locale: "en_US",
                            }
                        }
                    />
                </div>

                <div className='cov-divider'>
                    <Divider className='txt-devider'>Or</Divider>
                </div>
                <div className='use-anony'>
                    <Button
                        onClick={() => {
                            history.push("/home")
                        }}
                        className='text-anony'>Anonymous</Button>
                </div>


                <div className='cov-link'>
                    <p onClick={() => {
                        history.push("/policy")
                    }} className='text-term'>Privacy Policy</p>
                    <p onClick={() => {
                        history.push("/condition")
                    }} className='text-term'>Terms & Conditions</p>
                </div>
            </div>

        </div>
    )
}


export default Login
